<template>
  <div class="new-product body">
    <el-container>
      <!-- <ExpenseAside /> -->

      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="10" :lg="10" :md="24" :sm="24">
              <div
                class="searchForm"
                v-if="accessLinks('update_expense_category') && editMode"
              >
                <label for="">تعديل مصروف </label>
                <el-input
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="editForm.description"
                  @keyup.enter.native="updateCategory"
                ></el-input>
              </div>
              <div
                class="searchForm"
                v-if="accessLinks('add_expense_category') && !editMode"
              >
                <label for="">وصف مصروف </label>
                <el-input
                  class="mt-2 input1"
                  @focus="$event.target.select()"
                  v-model="form.description"
                  @keyup.enter.native="addNewCategory"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <br />
              <div
                v-if="accessLinks('update_expense_category') && editMode"
                class="mt-2"
              >
                <el-button type="warning" @click="updateCategory()">
                  تعديل</el-button
                >
                <el-button type="danger" class="mr-3" @click="cancelEdit()">
                  الغاء</el-button
                >
              </div>
              <el-button
                v-if="accessLinks('add_expense_category') && !editMode"
                class="mt-2"
                type="warning"
                @click="addNewCategory()"
              >
                تسجيل</el-button
              >
            </el-col>
          </el-row>
        </div>
        <h4 class="mt-4">
          <span>تصنيفات المصروفات</span>
        </h4>
        <section class="categories" v-if="accessLinks('list_expense_category')">
          <div
            v-for="category in categories"
            :key="category.id"
            class="category"
            style="margin-bottom: 10px"
          >
            <h6 class="mt-1">{{ category.description }}</h6>
            <div class="mt-2 mb-2 d-flex gap-3 justify-content-center">
              <div>
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  title="تعديل"
                  size="mini"
                  plain
                  v-if="accessLinks('update_expense_category')"
                  @click="editCategory(category)"
                ></el-button>
              </div>
              <div>
                <el-popconfirm
                  v-if="accessLinks('delete_expense_category')"
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  :title="'هل تريد حذف ' + ' ' + category.description + ' ؟'"
                  @confirm="deletecategory(category.id)"
                >
                  <el-button
                    slot="reference"
                    type="danger"
                    title="مسح"
                    plain
                    icon="el-icon-delete"
                    size="mini"
                    class="mr-3"
                  ></el-button>
                </el-popconfirm>
              </div>
            </div>
          </div>
        </section>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import ExpenseAside from "@/components/ExpenseAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewCategory",
  // components: { ExpenseAside },
  data() {
    return {
      index: 1,
      false: false,
      categories: [],
      form: {
        description: "",
      },
      editForm: {},
      editMode: false,
    };
  },
  created() {
    this.getCategories();
  },
  mounted() {},

  methods: {
    getCategories() {
      axiosApi
        .get("categories")
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    editCategory(category) {
      this.editMode = true;
      this.editForm = { ...category };
    },
    cancelEdit() {
      this.editMode = this.false;
    },
    deletecategory(id) {
      axiosApi
        .delete(`categories/${id}`)
        .then(() => {
          this.getCategories();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الوصف بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    addNewCategory() {
      axiosApi
        .post("categories", this.form)
        .then((res) => {
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الوصف بنجاح",
            type: "success",
            duration: 1500,
          });
          this.form.description = "";
          this.categories = res.data;
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    updateCategory() {
      this.editMode = this.false;
      axiosApi
        .put(`categories/${this.editForm.id}`, this.editForm)
        .then(() => {
          this.getCategories();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات الوصف بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>
<style scoped lang="scss">
.categories {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  .category {
    margin-bottom: 10px;
    padding: 19px 10px;
    border: 1px solid #eee;
    border-radius: 12px;
    background: #fff !important;
    box-shadow: 0 4px 25px 0 #00000008;

    > h6 {
      margin-bottom: 15px;
      text-align: center !important;
    }
  }
}
</style>
